var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-list-messages.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"dom-product-list-messages\">\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productListMessages") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productListMessages")),"error")) {
output += "\n\n        <div class=\"o-row c-product-message\">\n\n        \t<div class=\"o-column o-extra-small--12\">\n\n                <p class=\"c-product-message__info--error\" data-qa-product-list-msg-error>\n                    ";
output += runtime.suppressValue((lineno = 10, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "errorTranslation"), "errorTranslation", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productListMessages")),"error"),runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"skuInfo")),"secondarySlice")),"displayLabel")]})])), env.opts.autoescape);
output += "\n                </p>\n\n           </div>\n\n        </div>\n\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-list-messages.j2"] , dependencies)